import { api } from "../utilites/api";
import { ActivityLogReport } from '../models/activity-log-report-interface';
import { AddActivityLog } from "../models/activity-log-interface";
import { CompanyActivity } from "../models/company-activity-interface";

export const ActivityLogApi = {
  postActivityLog: (data: AddActivityLog[]) => api.post(`activityLog/add`, data),
  postGetActivityLogs: (companyId: number, data: ActivityLogReport) => api.post(`company/${companyId}/getActivityLogs`, data),
  postGetActivityLogsExportCsvFile: (companyId: number, data: ActivityLogReport) => api.postGetFile(`company/${companyId}/activitylog/export/csv/file`, data, '2.0'),
  getCompanyActivity: (companyId: number, days?: number, detail?: boolean) : Promise<CompanyActivity[]> => api.get(`company/${companyId}/getCompanyActivity?days=${days}&detail=${detail}`),
  getUserActivity: (userId: number) : Promise<CompanyActivity[]> => api.get(`user/${userId}/getCompanyActivity`)
}